import { convertDistrictToNumeric } from '../../utils'

export const formatInitialStaffValues = values => {
  let formattedValues = { ...values }
  formattedValues.district = convertDistrictToNumeric(values.district)
  return formattedValues
}
